import * as React from "react"

import
  { IOWidget
  , Options
  , option
  , mk_widget
  } from "../widget";

export type RadioOptions<A> =
  { selectedValue   : A
  , unselectedValue : A
  , disabled        : boolean
  } & Options

interface RadioProps<A>
  { options : RadioOptions<A>
  , input   : A
  , onDone  : (output: A) => void
}

interface RadioState<_a>  {  }

class Radio<A> extends React.Component<RadioProps<A>, RadioState<A>> {
  constructor(props: RadioProps<A>, context: any) {
    super(props, context)

    this.state = {}
  }

  render() {
    const props   = this.props
    const options = this.props.options

    return (
      <input
        id={option("id", options)}
        className={option("className", options)}
        key={option("key", options)}
        readOnly={option("readonly", options)}
        type={"radio"}
        checked={props.input == options.selectedValue}
        disabled={option("disabled", options)}
        onChange={e => props.onDone(
          e.currentTarget.checked
            ? options.selectedValue
            : options.unselectedValue
        )}
      />
    )
  }
}

/** @deprecated Use [[wrapHTML]] instead. */
export const radio = function<A>(options: RadioOptions<A>): IOWidget<A, A> {
  return (input: A) => mk_widget(
    { run: (onDone: (output: A) => void) =>
        React.createElement<RadioProps<A>>(Radio, { onDone, input, options })
    }
  )
}
